(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("adminLearningPlan", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/accounts/learningPlan/adminLearningPlanView.html",
            controller: ["accountsResource", "learningPlanResource", "messageService", "$state", "$sessionStorage", "_", AdminLearningPlanCtrl],
            controllerAs: "vm"
        };
        function AdminLearningPlanCtrl(accountsResource, learningPlanResource, messageService, $state, $sessionStorage, _) {
            var vm = this;
            vm.admin = true;
            vm.person = $state.params.personSeq;
            vm.categories = [];
            vm.filteredCategories = [];
            vm.search = "";
            vm.view = "tile";
            vm.loading = true;
            vm.filterPaths = filterPaths;
            vm.changeView = changeView;
            vm.getBands = getBands;
            vm.getPaths = getPaths;
            vm.visibilitOverride = visibilityOverride;
            if ($sessionStorage.adminLearningPlanView) {
                vm.view = $sessionStorage.adminLearningPlanView;
            }
            accountsResource.getName({ personSeq: vm.person }, function (data) {
                vm.fullName = data.value;
            }, angular.noop);
            learningPlanResource.get({ personSeq: vm.person }).$promise.then(function (data) {
                vm.data = data;
                vm.categories = data.categories;
                vm.bands = data.bands;
                vm.learningPaths = _.filter(data.learningPaths, function (path) {
                    return path.bandId !== null;
                });
                vm.uncategorizedPaths = _.filter(data.learningPaths, function (path) {
                    return path.bandId === null;
                });
                vm.filteredCategories = angular.copy(vm.categories);
                vm.filteredBands = angular.copy(vm.bands);
                vm.filteredPaths = angular.copy(vm.learningPaths);
                vm.filteredUncategorizedPaths = angular.copy(vm.uncategorizedPaths);
                if ($sessionStorage.adminLearningPlanSearch) {
                    vm.search = $sessionStorage.adminLearningPlanSearch;
                    vm.filterPaths();
                }
                vm.loading = false;
            }).catch(angular.noop);
            function getBands(categoryId) {
                return _.filter(vm.filteredBands, function (band) {
                    return band.categoryId === categoryId;
                });
            }
            function getPaths(bandId) {
                return _.filter(vm.filteredPaths, function (path) {
                    return path.bandId === bandId;
                });
            }
            vm.openPath = function (path) {
                if (path.assignmentStatus !== "GroupAssigned")
                    $state.go("main.people.viewLearningPath", { personSeq: vm.person, number: path.number, version: path.version });
            };
            function changeView(view) {
                vm.view = view;
                $sessionStorage.adminLearningPlanView = view;
            }
            function filterPaths() {
                $sessionStorage.adminLearningPlanSearch = vm.search;
                vm.filteredCategories = angular.copy(vm.categories);
                vm.filteredBands = angular.copy(vm.bands);
                vm.filteredPaths = angular.copy(vm.learningPaths);
                vm.filteredUncategorizedPaths = angular.copy(vm.uncategorizedPaths);
                if (vm.search.length !== 0) {
                    vm.filteredPaths = _.filter(vm.filteredPaths, function (path) {
                        return path.name.toLowerCase().indexOf(vm.search.toLowerCase()) > -1;
                    });
                    vm.filteredBands = _.filter(vm.filteredBands, function (band) {
                        return _.some(vm.filteredPaths, { bandId: band.bandId });
                    });
                    vm.filteredCategories = _.filter(vm.filteredCategories, function (category) {
                        return _.some(vm.filteredBands, { categoryId: category.categoryId });
                    });
                    vm.filteredUncategorizedPaths = _.filter(vm.filteredUncategorizedPaths, function (path) {
                        return path.name.toLowerCase().indexOf(vm.search.toLowerCase()) > -1;
                    });
                }
            }
            function visibilityOverride(path) {
                var current = path.visibilityOverride;
                if (current === true)
                    path.visibilityOverride = null;
                else if (current === null)
                    path.visibilityOverride = false;
                else if (current === false)
                    path.visibilityOverride = true;
                learningPlanResource.updateVisibilityOverride({ personSeq: vm.person, number: path.number, version: path.version }, { value: path.visibilityOverride }, function () {
                    // do nothing
                }, function () {
                    messageService.error("common.genericError");
                    path.visibilityOverride = current;
                });
            }
        }
    });
}());
